import React from "react";
import { Grid } from "@material-ui/core";
import AmountAxis from "./Graphics/AmountAxis";
import AmountSecretary from "./Graphics/AmountSecretary";
import AmountTypeProject from "./Graphics/AmountTypeProject";
import StatusProjects from "./Graphics/StatusProjects";
import api from "../../../../services/Api";
import { 
  CardSecretary, 
  CardProjects,
  CardSuspendedProjects,
  CardCanceledProjects,
  CardInProgressProjects,
  CardNotStartedProjects,
  CardCompletedProjects,
  CardProjectsTotal
} from "./Cards";
import ModalPhy from "./Graphics/ModalPhy";

/// infos ///
// total de projetos
// total de secretarias

/// graficos ///

// const setLabels = labels =>
//     setOpts({ ...opts, xaxis: { ...opts.xaxis, categories: labels } });
//https://codesandbox.io/s/boring-breeze-75pvw?file=/src/Chart.jsx
//https://codesandbox.io/s/cocky-gauss-d17vr

const GET_INFO = () => {
  return {
    method: "get",
    url: `dashboard/projectProperties.php`,
  };
};

const GET_TASK_SUSPENDED = () => {
  return {
    method: "get",
    url: `dashboard/projectCardSuspended.php`,
  };
};

const GET_TASK_CANCELED = () => {
  return {
    method: "get",
    url: `dashboard/projectCardCanceled.php`,
  };
};

const GET_TASK_IN_PROGRESS = () => {
  return {
    method: "get",
    url: `dashboard/projectCardInProgress.php`,
  };
};

const GET_TASK_NOT_STARTED = () => {
  return {
    method: "get",
    url: `dashboard/projectCardNotStarted.php`,
  };
};

const GET_TASK_COMPLETED = () => {
  return {
    method: "get",
    url: `dashboard/projectCardCompleted.php`,
  };
};

const init = {
  totalProject: undefined,
  totalSecretary: undefined,
  currentGroup: undefined,
  suspendedProjects: undefined,
  canceledProjects: undefined,
  inProgressProjects: undefined,
  notStartedProjects: undefined,
  completedProjects: undefined,
};

export default function StatisticsPanel() {
  const [data, setData] = React.useState(init);
  //{"totalProject":"15","totalSecretary":"11","currentGroup":{"id":"2","name":"Plano de Governo 2021 - 2024"}}

  const updateData = async () => {
    const newData = init

    api(GET_INFO())
      .then((r) => {
        console.log("totalProject", r.data)
        newData.totalProject = r.data.totalProject
        newData.totalSecretary = r.data.totalSecretary
        newData.currentGroup = r.data.currentGroup
      })
      .catch((e) => {
        setData(init);
      });

    api(GET_TASK_SUSPENDED())
      .then((r) => {
        newData.suspendedProjects = r.data.valor ? r.data.valor : "0"
      })
      .catch((e) => {
        console.log(e);
      });

    api(GET_TASK_CANCELED())
      .then((r) => {
        newData.canceledProjects = r.data.valor ? r.data.valor : "0"
      })
      .catch((e) => {
        console.log(e);
      });

    api(GET_TASK_IN_PROGRESS())
      .then((r) => {
        newData.inProgressProjects = r.data.valor ? r.data.valor : "0"
      })
      .catch((e) => {
        console.log(e);
      });

    api(GET_TASK_NOT_STARTED())
      .then((r) => {
        newData.notStartedProjects = r.data.valor ? r.data.valor : "0"
      })
      .catch((e) => {
        console.log(e);
      });

    api(GET_TASK_COMPLETED())
      .then((r) => {
        newData.completedProjects = r.data.valor ? r.data.valor : "0"
      })
      .catch((e) => {
        console.log(e);
      });

    setData(newData);
  };

  React.useEffect(() => {
    updateData();
  }, []);

  console.log("data", data)

  const projectsTotal = data ? parseFloat(data.suspendedProjects) + parseFloat(data.canceledProjects) + parseFloat(data.inProgressProjects) + parseFloat(data.notStartedProjects) + parseFloat(data.completedProjects) : 0

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={2}
    >
      <Grid
        xs={12}
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={2}
        style={{ padding: "0.5rem" }}
      >
        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <CardProjects value={data.totalProject} />
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <CardSecretary value={data.totalSecretary} />
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <CardSuspendedProjects value={data.suspendedProjects} />
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <CardCanceledProjects value={data.canceledProjects} />
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <CardInProgressProjects value={data.inProgressProjects} />
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <CardNotStartedProjects value={data.notStartedProjects} />
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <CardCompletedProjects value={data.completedProjects} />
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <CardProjectsTotal value={projectsTotal} />
        </Grid>
      </Grid>

      <Grid
        xs={12}
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={2}
        style={{ padding: "0.5rem" }}
      >
        
      </Grid>

      <Grid item xs={12} sm={12} md={8}>
        <AmountSecretary />
      </Grid>

      <Grid item xs={12} sm={12} md={4}>
        <StatusProjects />
      </Grid>

      <Grid item xs={12} sm={12} md={8}>
        {data?.currentGroup !== undefined ? (
          <AmountAxis group={data.currentGroup} />
        ) : null}
      </Grid>

      <Grid item xs={12} sm={12} md={4}>
        {data?.currentGroup !== undefined ? (
          <AmountTypeProject group={data.currentGroup} />
        ) : null}
      </Grid>

      <Grid item xs={12}>
        <ModalPhy />
      </Grid>
    </Grid>
  );
}

/*
etapas por secretaria
          - responsavel
          - Prioridade
          - Recurso $$

Resolvido     - secretaria
              - responsavel
              - Prioridade
              - Recurso $$


Não resolvido - secretaria
              - responsavel
              - Prioridade
              - Recurso $$
              
https://codesandbox.io/s/react-google-charts-column-chart-6o1dy?file=/src/index.js

*/
